import { Edit, Create } from 'react-admin';
import { SegmentList as SegmentListComponent } from './SegmentList';
import SegmentForm from './SegmentForm';

//Note: it's a bit redundant to do this instead of direct importing into App.js, but we may want to add additional logic and UI later
export const SegmentList = SegmentListComponent;
export const SegmentEdit = props => ( <Edit mutationMode="pessimistic" {...props}><SegmentForm {...props}/></Edit> )
export const SegmentCreate = props => ( <Create {...props}><SegmentForm {...props}/></Create> )